import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=53f933e4&scoped=true"
import script from "./questionList.vue?vue&type=script&setup=true&lang=js"
export * from "./questionList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./questionList.vue?vue&type=style&index=0&id=53f933e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f933e4",
  null
  
)

export default component.exports